import { useParams } from 'react-router-dom';

export default function AdminCampanhaDetalhes() {
  const { id } = useParams();
  
  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold mb-6">Campanha {id}</h1>
      <p className="text-gray-600">Detalhes em desenvolvimento</p>
    </div>
  );
}
